module.exports = __webpack_public_path__ + "static/media/arrow-left.85dd2182.svg";